var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.1666H22.5M10 27.5H13.3333M17.5 27.5H24.1667M36.6667 20.05V26.85C36.6667 32.7 35.1833 34.1666 29.2667 34.1666H10.7333C4.81666 34.1666 3.33333 32.7 3.33333 26.85V13.15C3.33333 7.29998 4.81666 5.83331 10.7333 5.83331H22.5M28.8477 13.6493L35.3143 7.1826M35.3143 13.6493L28.8477 7.1826",
    stroke: "#9F5448",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.ab494b40d7125c715eba7d82f5f53405.svg";
export { ForwardRef as ReactComponent };